import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ApplyForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNo: '',
    email: '',
    resume: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, phoneNo, email, resume } = formData;

    if (!firstName || !lastName || !phoneNo || !email || !resume) {
      alert('All fields are required!');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('firstName', firstName);
    formDataToSend.append('lastName', lastName);
    formDataToSend.append('phoneNo', phoneNo);
    formDataToSend.append('email', email);
    formDataToSend.append('resume', resume);

    try {
      const response = await fetch('http://localhost:5000/api/apply', {
        method: 'POST',
        body: formDataToSend,
      });
      if (response.ok) {
        navigate('/application-success'); // Redirect to success page
      } else {
        alert('Failed to submit application.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleCancel = () => {
    navigate(`/job/${id}`);
  };

  return (
    <form className="apply-form" onSubmit={handleSubmit}>
      <label>First Name:</label>
      <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
      <label>Last Name:</label>
      <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
      <label>Phone No:</label>
      <input type="text" name="phoneNo" value={formData.phoneNo} onChange={handleChange} required />
      <label>Email:</label>
      <input type="email" name="email" value={formData.email} onChange={handleChange} required />
      <label>Upload Resume (PDF or Word):</label>
      <input type="file" name="resume" onChange={handleFileChange} accept=".pdf,.doc,.docx" required />
      <button type="button" onClick={handleCancel}>Cancel</button>
      <button type="submit">Submit</button>
    </form>
  );
};

export default ApplyForm;